/**
 * SessionStorageService
 * Handles tab-specific storage (isolated per browser tab)
 * Used for tracking which user role is active in the current tab
 */
export class SessionStorageService {
  /**
   * Set the currently active user role in this tab
   */
  setCurrentRole = (role: number | string): void => {
    sessionStorage.setItem("currentUserRole", role.toString());
  };

  /**
   * Get the currently active user role in this tab
   */
  getCurrentRole = (): string | null => {
    return sessionStorage.getItem("currentUserRole");
  };

  /**
   * Clear the current role (used on logout)
   */
  clearCurrentRole = (): void => {
    sessionStorage.removeItem("currentUserRole");
  };

  /**
   * Check if a role is active in this tab
   */
  hasActiveRole = (): boolean => {
    return sessionStorage.getItem("currentUserRole") !== null;
  };

  /**
   * Generic sessionStorage operations
   */
  set = (key: string, value: string): void => {
    sessionStorage.setItem(key, value);
  };

  get = (key: string): string | null => {
    return sessionStorage.getItem(key);
  };

  remove = (key: string): void => {
    sessionStorage.removeItem(key);
  };

  /**
   * Clear all session storage for this tab
   */
  clear = (): void => {
    sessionStorage.clear();
  };
}
